import zwitCore from "./http";
const BASE_URL = "/apis/zw-user";
import { jsonp } from 'vue-jsonp'
export default {
  getPk() {
    return zwitCore.HTTP.get(BASE_URL + "/getPk");
  },
  // 获取公网ip地址接口
  async getUserIpConfig() {
    const isValidIp = (ip) => {
        if (!ip) return false;
        // 兼容 IPv4 / IPv6 的基础校验，避免写入空值或异常值
        return /^(?:\d{1,3}\.){3}\d{1,3}$/.test(ip) || /^[0-9a-fA-F:]+$/.test(ip);
    };

    const services = [
        { url: 'https://api.ipify.org?format=json', key: 'ip' },
        { url: 'https://api.ip.sb/geoip', key: 'ip' },
        { url: 'https://ipwho.is/', key: 'ip' },
    ];

    for (const service of services) {
        try {
            const controller = new AbortController();
            const timer = window.setTimeout(() => controller.abort(), 3500);
            const response = await fetch(service.url, {
                method: 'GET',
                signal: controller.signal,
            });
            window.clearTimeout(timer);

            if (!response.ok) continue;

            const data = await response.json();
            const ip = data?.[service.key];
            if (isValidIp(ip)) {
                return ip;
            }
        } catch (error) {
            // 单个免费服务失败时继续尝试下一个
            continue;
        }
    }

    return '';
  }
};
